import React from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import authorActions from "../homepage/authorActions";
import {SecondaryButton} from "../../elements/Buttons";
import {hideNotifications} from "../../notification/notificationActions";
import {logAction} from "../../../logging/logEvent";

const Button = styled(SecondaryButton)`
    flex-shrink: 0;
    flex-grow: 1;
    margin-top: 0;
    margin-right: 8px;
    font-weight: normal;
`;

const CreateIdeaModalButton = ({}) => {
    const {ideaManagementBlocked, userRole} = useSelector(({userIdentity: {ideaManagementBlocked, userRole}}) => ({ideaManagementBlocked, userRole}));
    const dispatch = useDispatch();

    if (ideaManagementBlocked || userRole !== "AUTHOR") {
        return null;
    }

    function onCreateIdeaClick() {
        logAction({type: "CREATE_IDEA_SCREEN_OPENED"});
        dispatch(hideNotifications());
        authorActions(dispatch).showCreateScreen(true);
    }

    return (
        <Button className="t-create-idea-modal-button" onClick={onCreateIdeaClick}>
            <div>Create Idea</div>
        </Button>
    );
};

export default CreateIdeaModalButton;
